import { Activity, Match, Shortlist } from "PFTypes";
import React, { PropsWithChildren, useContext, useMemo } from "react";
import { useToggle } from "react-use";

type MatchCardProviderProps = Match & {
  role: Activity;
  shortlists: Shortlist[] | null;
  isCompressed?: boolean;
};

export type MatchCardContextType = Omit<MatchCardProviderProps, "isCompressed"> & {
  isOpen: boolean;
  toggleIsOpen: (open?: boolean) => void;
  isCompressed: boolean;
  animationTrigger: boolean;
  animate: VoidFunction;
};

const MatchCardContext = React.createContext<MatchCardContextType>({} as MatchCardContextType);

export const MatchCardProvider = ({
  children,
  isCompressed,
  ...matchCardProps
}: PropsWithChildren<MatchCardProviderProps>) => {
  const [isOpen, toggleIsOpen] = useToggle(false);
  const [animationTrigger, animate] = useToggle(false);

  const contextValue = useMemo(
    () => ({
      toggleIsOpen,
      isOpen,
      isCompressed: !!isCompressed,
      animationTrigger,
      animate,
      ...matchCardProps
    }),
    [toggleIsOpen, isOpen, isCompressed, animationTrigger, animate, matchCardProps]
  );
  return <MatchCardContext.Provider value={contextValue}>{children}</MatchCardContext.Provider>;
};

export const useMatchCardContext = () => useContext(MatchCardContext);
